import {IRegulationPresetValues} from '../regulation-preset-values.interface';
const overrideJson = require('json-override');

function createCommonPresetValues(): IRegulationPresetValues {
    return {
        sdk: {
            Skin: {
                regulationID: 6,
                brandID: null,
                subBrandID: null,
            },
            Currency: {
                anonymousCurrency: 'USD'
            },
            OAuth2: {
                fakeClientIP: '96.245.192.172'
            }
        },
        orbit: {
            country: 'usa',
            language: 'eng',
            iso2: 'en',
            publicationID: null,
            cmsSource: null
        }
    }
}

export const DELAWAREPARK_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 70,
            subBrandID: 102
        }
    },
    orbit: {
        publicationID: 1981,
        cmsSource: 'https://casino.delawarepark.com'
    }
});

export const DOVERDOWNS_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 69,
            subBrandID: 100
        },
        Currency: {
            anonymousCurrency: 'USD'
        },
        OAuth2: {
            fakeClientIP: '96.245.192.172'
        }
    },
    orbit: {
        publicationID: 1978,
        cmsSource: 'https://onlinecasino.doverdowns.com'
    }
});
export const HARRINGTON_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 68,
            subBrandID: 98
        },
    },
    orbit: {
        publicationID: 1980,
        cmsSource: 'https://casino.harringtongamingonline.com'
    }
});
